import { makeEntityScaffold } from '@classpass/saga-tools';
import { SpotsUpdateRequest } from '@classpass/protobuf-definitions/lib/web/models/partners/schedule';

import URLS from 'constants/urls';

const act = (httpClient, venueId, scheduleId, classpassSpots, ssEnabled, withAllFutures) => {
  const endpoint = URLS.schedule.updateSpots(venueId, scheduleId);

  // Use the same protobuf serialization as the roster view
  // Don't include with_all_futures if it's false (matching roster behavior)
  const requestPayload = {
    spots: classpassSpots,
    ss_enabled: ssEnabled,
  };

  if (withAllFutures) {
    requestPayload.with_all_futures = withAllFutures;
  }

  const requestBody = SpotsUpdateRequest.toJSON(requestPayload);

  return httpClient.put(endpoint, requestBody).then(response => {
    // This endpoint returns the updated schedule data directly in response.data
    return response.data;
  });
};

const handler = ({ httpClient }, { venueId, scheduleId, classpassSpots, ssEnabled, withAllFutures }) => {
  return act(httpClient, venueId, scheduleId, classpassSpots, ssEnabled, withAllFutures);
};

export default makeEntityScaffold('SAGA.API.VENUE.SMARTSPOT_SINGLE_UPDATE', handler, {
  defaultKey: (_, { venueId, scheduleId }) => `${venueId}-${scheduleId}`,
});
